import React from "react";
import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import Lottie from "lottie-react";
import { HiInformationCircle } from "react-icons/hi";

import creatingMontage from "animations/creatingMontage.json";
import { Title2, Body, Subheader } from "MVVM/Components/Text";

export const CareerMontagePending = ({
  title = "Career Montage",
}: {
  title: string;
}) => {
  return (
    <CareerMontagePendingContent flexDirection="column" maxWidth="100%">
      <CareerMontagePendingBox flex={1}>
        <Flex
          justifyContent={["space-between"]}
          alignItems={["flex-start", "flex-start", "center"]}
          flexDirection={["column", "column", "row"]}
        >
          <CareerMontageHeaderFlex flexDirection={"row"} alignItems="center">
            <CareerMontageAnimationContainer>
              <CareerMontageAnimation
                animationData={creatingMontage}
                loop={true}
              />
            </CareerMontageAnimationContainer>
            <Flex flexDirection="column">
              <CareerMontageTitle mb={1}>{title}</CareerMontageTitle>
              <CareerMontageBody color="chalk">
                Your Career Montage is being processed.
              </CareerMontageBody>
            </Flex>
          </CareerMontageHeaderFlex>
          <CareerMontageMessage>
            <Flex alignItems="center" mb={2}>
              <CareerMontageInfoIcon />
              <CareerMontageMessageTitle ml={2}>
                Montage On Its Way
              </CareerMontageMessageTitle>
            </Flex>
            <CareerMontageMessageBody>
              Your clip is on the way! Please check the estimated time of
              arrival for delivery.
            </CareerMontageMessageBody>
          </CareerMontageMessage>
        </Flex>
      </CareerMontagePendingBox>
    </CareerMontagePendingContent>
  );
};

const CareerMontagePendingContent = styled(Flex)`
  gap: 30px;
  max-width: 800px;
  padding: 20px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breaks.standard}) {
    flex-direction: column;
    padding: 15px;
  }

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    padding: 10px;
  }
`;

const CareerMontagePendingBox = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.navy};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
  padding: 30px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    padding: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    padding: 15px;
  }
`;

const CareerMontageHeaderFlex = styled(Flex)`
  width: 50%;

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    padding: 0 0 10px 3px;
    width: 100%;
  }
`;

const CareerMontageTitle = styled(Title2)`
  color: ${({ theme }) => theme.colors.ice};
  font-weight: 600;
`;

const CareerMontageBody = styled(Body)`
  font-weight: 600;
`;

const CareerMontageAnimationContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

const CareerMontageAnimation = styled(Lottie)`
  height: 48px;
  width: 48px;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    height: 24px;
    width: 24px;
  }
`;

const CareerMontageMessage = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.midnightAlpha40};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha20};
  border-radius: 8px;
  flex-direction: column;
  max-width: 420px;
  min-width: 200px;
  padding: 30px;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    padding: 15px;
  }

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    margin-top: 20px;
    max-width: unset;
    padding: 15px;
  }
`;

const CareerMontageInfoIcon = styled(HiInformationCircle)`
  color: ${({ theme }) => theme.colors.envy};
  flex-shrink: 0;
  height: 24px;
  width: 24px;
`;

const CareerMontageMessageTitle = styled(Subheader)`
  color: ${({ theme }) => theme.colors.ice};
  font-weight: 600;
`;

const CareerMontageMessageBody = styled(Subheader)`
  color: ${({ theme }) => theme.colors.chalk};
`;
